import Cookies from 'js-cookie';
import { SupportedLanguage } from 'src/common/contexts/language-context';

export const detectBrowserLanguage = (): boolean => {
  const browserLang = navigator.language.toLowerCase();
  if (browserLang.startsWith('fr')) {
    return true;
  }
  return false;
};

/**
 * Get the user's language preference from cookies - useful for route loaders and other contexts
 * where the Language context is not available
 */
export const getUserLanguagePreference = (): SupportedLanguage | null => {
  const storedLanguage = Cookies.get('thm-user-language-preference');
  if (storedLanguage && Object.values(SupportedLanguage).includes(storedLanguage as SupportedLanguage)) {
    return storedLanguage as SupportedLanguage;
  }
  return null;
};

/**
 * Check if user has set a language preference
 */
export const hasUserLanguagePreference = (): boolean => {
  return Cookies.get('thm-user-language-preference') !== undefined;
};

/**
 * Get the effective language based on user preference, feature flag, and browser detection
 * This respects user preference but doesn't override the feature flag for analytics
 */
export const getCurrentLanguage = (isFrenchFeatureFlagEnabled: boolean): SupportedLanguage => {
  // Priority: User preference > Feature flag > Browser detection > Default (English)
  const userPreference = getUserLanguagePreference();
  if (userPreference) {
    return userPreference;
  }

  if (isFrenchFeatureFlagEnabled && detectBrowserLanguage()) {
    return SupportedLanguage.FRENCH;
  }

  return SupportedLanguage.ENGLISH;
};

/**
 * Get whether French should be used based on user preference and feature flag
 */
export const shouldUseFrench = (isFrenchFeatureFlagEnabled: boolean): boolean => {
  return getCurrentLanguage(isFrenchFeatureFlagEnabled) === SupportedLanguage.FRENCH;
};
